<template>
    <div class="posts-wrapper">
      <div class="packages orders">
     
        <div class="filters">
          <div class="title">Búsqueda</div>
          <div class="wrap-filter">
              <div class="item">
                <vs-input label="Cliente" v-model="customerName"/>
              </div>
              <div class="item">
                <vs-input label="Tracking" v-model="tracking"/>
              </div>
              <div class="item">
                <label for="">Fechas</label>
                <v-date-picker mode="range" v-model="dateFilter" locale="es" :popover="{ placement: 'top', visibility: 'click' }"></v-date-picker>
              </div>
              <div class="item">
                <vs-input label="Ubicación" v-model="location"/>
              </div>
              <div class="item btnFilter">
                  <vs-button id="btnFilter" class="vs-con-loading__container"  color="primary" type="border" icon="search" @click="retrievePackages()">Filtrar paquetes</vs-button>
              </div>
          </div>
        </div>
        
        <div class="box-white-wrapper" v-if="packages.length > 0">

          <div class="new-order">
            <vs-input label="Comentarios" v-model="notes"/>
            <vs-button id="btnFilter" class="vs-con-loading__container"  color="primary" type="border"  :disabled="updateMultiplePacks.length < 1 || notes == '' ? true : false" @click="newOrder()">Nuevo orden</vs-button>
  
          </div>
          
          <p class="disclaimer">Favor asignar al menos un paquete a la orden de despacho.</p>
        <!-- {{ tempPackges }} -->
            <vs-table :data="tempPackges" pagination max-items="50" :key="keyPackages">
              <template slot="thead">
                  <vs-th sort-key="id" class="width-30" v-if="userInfoData.role == Roles.Admin"></vs-th>
                  <vs-th sort-key="tracking">Tracking</vs-th>
                  <vs-th sort-key="firstName">Nombre </vs-th>
                  <vs-th sort-key="createdAt"> Producto </vs-th>
                  <vs-th sort-key="statusname"> Ubicación </vs-th>
              </template>
              <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                    <vs-td class="switchMultiplePacks" v-if="userInfoData.role == Roles.Admin">
                      <vs-checkbox color="#1a426d" v-model="updateMultiplePacks"  :vs-value="data[indextr]"></vs-checkbox>
                    </vs-td>
                    <vs-td :data="data[indextr].tracking" class="nopl">
                      <div class="d-flex">
                        {{data[indextr].tracking}}
                      </div>
                    </vs-td>
                    <vs-td :data="data[indextr].customername">
                        {{data[indextr].customername}}
                    </vs-td>
                    <vs-td :data="data[indextr].productName">
                        {{data[indextr].productName}}
                    </vs-td>
                    <vs-td :data="data[indextr].ubication">
                        {{data[indextr].ubication}}
                    </vs-td>                    
                  </vs-tr>
              </template>
          </vs-table>

        </div>
      </div>
      <displayInformation v-if="packages.length < 1" message="No se han encontrado paquetes para despachar." :showButton="false"></displayInformation>
    </div>
</template>
<script>
import { mapState, } from 'vuex'
import {helper} from '@/helpers/utils'
import { Role } from '@/helpers/Role.js'
import { required } from 'vuelidate/lib/validators'
import DisplayInformation from '@/components/DisplayInformation.vue'
import InventoryService from "@/services/InventoryService"
export default {
  name: 'Packages',
  mixins: [helper],
  components: { DisplayInformation },
  data () {
    return {
      keyPackages: 0,
      typeChangeSt: false,
      updateMultiplePacks: [],
      Roles: [],
      filterObj: {
        dateFilter: null,
        status: null,
        filter: ""
      },
      colorSelected: '',

      notes: "",
      packages: [],
      
      invId: '',
      tracking: "",
      customerName:"",
      location: "",
      dateFilter: '',
      tempPackges: [],

    }
  },
  created(){
    this.Roles = Role
  },
  computed: {
    ...mapState([
      'userInfoData'
    ]),
  },
  beforeMount() {
    this.$Progress.start();
  },
  mounted (){
    this.retrievePackages();
  },
  validations: {
    package: 
      { 
        status: { required },
      },
  },
  methods: {
    newOrder() {
        this.loadingProgress ('#btnFilter', "#1a426d")
        InventoryService.newDispatch({notes: this.notes, details: this.updateMultiplePacks})
        .then(response => {
            console.log(response);
            
            this.$vs.notify({title:'Información!',text:'La solicitud de despacho fue registrada exitosamente!',color:'success',icon:'check'})
            
            this.$router.push({ name: "OrderDetail", params:{ id: response.data.obj.id }})

        })
        .catch(e => {
          console.log(e)
          this.$Progress.finish()
          this.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
          this.$vs.notify({title:'Error!',text:'Error obteniendo los paquetes!',color:'danger',icon:'error_outline'})
        });
    },
    
    changePackageStatus(value, type){
      if(this.userInfoData.role != 'Customer'){
        this.packageId    = value
        this.typeChangeSt = type != 'single' ? true : false;
        type != 'single' ? true : false;
        if(type == 'single'){
          this.pkgCurrentStatus = this.currentPackStatus(value)
        }
        this.modalActive = true
      }
    },
    
    retrievePackages() {
      
      let obj = {
        "tracking": this.tracking,
        "customerName" : this.customerName,
        "ubication" : this.location
      }

      if(this.dateFilter != '' && this.dateFilter != null) {
        obj.begDa = this.$moment(this.dateFilter.start).format('YYYY/MM/DD');
        obj.endDa = this.$moment(this.dateFilter.end).format('YYYY/MM/DD');
      }

      InventoryService.getPacksDispatch(obj)
        .then(response => {
            console.log(response);
            this.packages    = response.data.records;
            this.tempPackges = this.packages
            this.updateMultiplePacks = this.packages;
            this.$Progress.finish()
        //   this.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
        //   this.noLimit = false
        //   this.keyPackages++
        })
        .catch(e => {
          console.log(e)
          this.$Progress.finish()
          this.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
          this.$vs.notify({title:'Error!',text:'Error obteniendo los paquetes!',color:'danger',icon:'error_outline'})
        });
    },
    
    
    
  }
}
</script>
